import { useEffect } from "react";
import { Link, useParams } from "react-router";
import { useAtomValue } from "jotai";
import { Lock } from "lucide-react";
import { localeAtom } from "../stores/locale";
import { t } from "../lib/i18n";
import { track } from "../lib/posthog";

// SeatGate is the full-page state shown when the active galaxy is private-mode
// and the viewer holds no paid seat (the BE returns 402 needs_seat). Public
// galaxies never hit this. Rendered by Layout in place of the galaxy view; the
// sidebar/galaxy-switcher stays so the viewer can move to a galaxy they can see.
export default function SeatGate() {
  const { account = "" } = useParams<{ account: string }>();
  const locale = useAtomValue(localeAtom);

  // Conversion moment: the org seat wall is now in front of the user. Fire once
  // per mount so the funnel can measure wall → upgrade_clicked → paid (and drop-off).
  useEffect(() => {
    track.paywallHit("seat");
  }, []);

  return (
    <div className="flex min-h-[60vh] items-center justify-center px-2xl">
      <div
        className="max-w-[28rem] rounded-xl p-3xl text-center"
        style={{ border: "1px solid var(--border)", background: "var(--surface-sunken)" }}
      >
        <div
          className="mx-auto mb-lg flex h-12 w-12 items-center justify-center rounded-full"
          style={{ background: "var(--bg-card)", border: "1px solid var(--border)" }}
        >
          <Lock size={20} style={{ color: "var(--text-muted)" }} />
        </div>
        <h2 className="text-lg font-medium" style={{ color: "var(--text-strong)" }}>
          {t("seatGate.title", locale)}
        </h2>
        <p className="mt-md text-sm leading-relaxed" style={{ color: "var(--text-muted)" }}>
          {t("seatGate.body", locale)}
        </p>
        <p className="mt-sm text-xs leading-relaxed" style={{ color: "var(--text-dim)" }}>
          {t("seatGate.publicNote", locale)}
        </p>
        <Link
          to={`/${account}/plan`}
          className="btn-gold mt-xl inline-block rounded-lg px-xl py-md text-sm"
        >
          {t("seatGate.cta", locale)}
        </Link>
      </div>
    </div>
  );
}
